module.exports = __webpack_public_path__ + "static/img/lucky-bag.5f72f45.png";